<template>
  <div>
    <div class="find_pwd2">
      <p class="Ppersonal_infoTop">
        <span @click="back"><img src="../../assets/images/users/Return.png"></span>
        <span>パスワード変更</span>
        <span></span>
      </p>
      <p class="personal_infoTop">パスワード変更</p>
      <div class="find_pwd_input inputOne">
        <input name="changePwd" v-model="changePwd" type="password" placeholder="パスワード:6~16文字のアルファベットと数字。">
        <span v-show="errors.has('changePwd')" class="error">{{ errors.first('changePwd') }}</span>
      </div>
      <div class="find_pwd_input">
        <input name="changeRepwd" v-model="changeRepwd" type="password" placeholder="パスワード確認:">
        <span v-show="errors.has('changeRepwd')" class="error">{{ errors.first('changeRepwd') }}</span>
      </div>
      <button @click="finish">修正確認</button>
    </div>
  </div>
</template>

<script>
  let Base64 = require('js-base64').Base64;
  import {isValidUuid, updatePwd} from './../../api/interface/users'
  import VeeValidate, {Validator} from 'vee-validate'
  import cn from 'vee-validate/dist/locale/zh_CN'
  Validator.localize('cn', cn);
  const dict = {
    cn: {messages: {required: (name) => `${name}必要!`}}
  };
  Validator.localize(dict);
  export default{
    name: "",
    validator: null,
    data(){
      return {
        errors: null,
        start: false,
        changePwd: "",
        changeRepwd: "",
        email: '',
        uuid: ''
      }
    },
    methods: {

      isValidUuid(){
        let userInfo = {
          email: this.email,
          uuid: this.uuid
        };
        isValidUuid(userInfo).then(result => {
        }).catch(err => {
          console.log("验证不通过跳转login");
          this.$router.push({
            path: '/login'
          })
        })
      },
      finish(){
        this.validator.validateAll({
          changePwd: this.changePwd,
          changeRepwd: this.changeRepwd,
        }).then(result => {
          let userInfo = {
            pwd: this.changePwd,
            rePwd: this.changeRepwd,
            email: this.email
          };
          if (result) {
            updatePwd(userInfo).then(resultData => {
              this.$message({
                message: 'パスワード再設定しました、ロクインページに移動します。',
                type: 'success'
              });
              setTimeout(() => {
                this.$router.push({path: "/login"})
              }, 2500);
            }).catch(err => {
              console.log(err);
//              console.log("更新失败，查看返回信息3.3.3.3.3. ")
            })
          }
        })
      },
      getUrlKey(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      },
      back(){
        this.$router.go(-1)
      }
    },
    created(){
      console.log("location.href");
      console.log(location.href);
      let uuid = this.getUrlKey("uuid") || 0;
      console.log(uuid);
      let uuidStr = Base64.decode(uuid);
      console.log(uuidStr);
      let uuidJson = JSON.parse(uuidStr);
      console.log(uuidJson);
      this.uuid = uuidJson.uuid;
      this.email = uuidJson.email;
      console.log(this.email);
      console.log(this.uuid);
      if (!this.uuid || !this.email) {
        this.$router.push({
          path: '/login'
        })
      } else {
        this.isValidUuid()
      }


      this.validator = new Validator({});  // 初始化Validator对象
      Validator.extend('changePwd', {
        getMessage: field => '入力内容が正しくありません',
        validate: value => /[0-9a-zA-Z]{6,16}/.test(value)  // 验证条件
      });
      Validator.extend('changeRepwd', {
        getMessage: field => 'パスワードが一致しません',
        validate: value => this.reg_pwd === this.reg_conpwd // 验证条件
      });
      this.validator.attach({name: 'changePwd', rules: 'required|changePwd|', alias: 'パスワード'});
      this.validator.attach({name: 'changeRepwd', rules: 'required', alias: 'パスワード確認'});
      this.$set(this, 'errors', this.validator.errors);
    },
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: 0px) and(max-width: 749px) {
    .find_pwd2 {
      width: 100%;
      letter-spacing: $letter;
      .Ppersonal_infoTop {
        height: 40px;
        line-height: 40px;
        background-color: $TitColor;
        width: 100%;
        color: white;
        display: flex;
        font-size: 16/$default-w+rem;
        justify-content: space-between;
        span:nth-child(1),
        span:nth-child(3) {
          height: 30px;
          width: 30px;
          margin-left: 7.5px;
        }
        img {
          margin-top: 5px;
        }
      }
      .personal_infoTop {
        display: none;
      }
      input {
        border: none;
        outline: none;
      }
      .error {
        color: red;
        font-size: 12px;
        margin-top: 5px;
      }
      .find_pwd_input {
        height: 35px;
        width: 286px;
        border: 1px solid $fontColor;
        margin: 0 auto;
        margin-top: 25px;
        border-radius: 5px;
        background-color: white;
        input {
          height: 34px;
          width: 280px;
          margin-left: 6px;
          border-radius: 5px;
        }
      }
      .inputOne {
        margin-top: 100px;
      }
      button {
        border-radius: 5px;
        height: 30px;
        width: 70%;
        margin-left: 15%;
        margin-top: 40px;
        border: none;
        outline: none;
        background-color: #595758;
        color: $whiteColor;
      }
    }
  }

  @media screen and(min-width: 750px) {
    .find_pwd2 {
      width: 400px;
      margin: 180px auto;
      .Ppersonal_infoTop {
        display: none;
      }
      .personal_infoTop {
        height: 20px;
        width: 100%;
        text-align: center;
        line-height: 20px;
        font-size: 16px;
      }
      input {
        border: none;
        outline: none;
      }
      .error {
        color: red;
        font-size: 12px;
        margin-top: 5px;
      }
      .find_pwd_input {
        height: 35px;
        width: 386px;
        border: 1px solid $fontColor;
        margin: 0 auto;
        margin-top: 40px;
        border-radius: 5px;
        background-color: white;
        input {
          height: 34px;
          width: 380px;
          margin-left: 6px;
          border-radius: 5px;
        }
      }
      button {
        border: none;
        outline: none;
        color: white;
        height: 30px;
        width: 290px;
        background-color: $fontColor;
        margin-left: 55px;
        margin-top: 50px;
        text-align: center;
        border-radius: 5px;
        line-height: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/users/updatePwd.vue